<template>
  <div class="content">
    <h4 class="form-title flex-row-align-center">
      <i class="material-icons mar-right-10">face</i>Profile Details
    </h4>
    <div class="form-row mar-top-10">
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">Full Name</label>
        <input
          type="text"
          v-model="username"
          placeholder="Enter your full name"
        />
      </div>
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">Email</label>
        <input type="text" v-model="email" placeholder="hello@example.com" />
      </div>
    </div>
    <!-- <h4 class="form-title mar-top-30 flex-row-align-center">
      <i class="material-icons mar-right-10">lock</i>Password
    </h4>
    <div class="form-row mar-top-10">
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">Current Password</label>
        <input type="text" name id placeholder="Enter your current password" />
      </div>
      <div class="flex-col flex-expand"></div>
    </div>
    <div class="form-row mar-top-10 pad-bottom-20 border-bottom">
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">New Password</label>
        <input type="text" name id placeholder="Enter your new password" />
      </div>
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">Re Enter Passowrd</label>
        <input type="text" name id placeholder="Enter your new password again" />
      </div>
    </div>
    <div class="button-row">
      <button class="button">SAVE</button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      username: "",
      email: "",
    };
  },
  computed: {
    ...mapGetters("User", ["getUserData"]),
  },
  mounted() {
    (this.username = this.getUserData.name),
      (this.email = this.getUserData.email);
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;

  .form-title {
    font-weight: bold;
  }

  .form-row {
    display: flex;
    flex-direction: row;
    justify-content: center;

    @include respond-below(md) {
      flex-direction: column;
    }
  }

  .button-row {
    display: flex;
    padding-top: 10px;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
